export default __webpack_public_path__ + "static/media/slider_image_03-lg@2x.5fd271f3.jpg";